import styled, { css } from 'styled-components'

import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Theme } from '@mui/material'
import { colors } from '@theme/variables'

export const IntroSectionWrapper = styled('div')<{ theme: Theme }>`
  display: flex;
  align-items: center;
  gap: 24px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
  }
`

export const IntroImagesContainer = styled('div')`
  height: 100%;
`

export const IntroImageBox = styled('div')<{ theme: Theme }>`
  min-width: 218px;
  max-width: 218px;
  height: 222px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`

export const IntroSectionImage = styled('img')`
  width: 100%;
  height: 100%;
`

export const IntroContentBox = styled('div')<{ theme: Theme }>`
  width: 280px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
  }
`

export const IntroTitle = styled('div')`
  color: ${colors.darkBlue};
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
`

export const IntroButton = styled('button')<{ $height?: string }>`
  margin-top: 22px;
  border-radius: 4px;
  padding-left: 14px;
  height: 37px;
  gap: 6px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${colors.white};
  background: ${colors.primary};
  cursor: pointer;
  width: fit-content;
  border: none;

  ${({ $height }: { $height?: string }) =>
    $height
      ? css`
          height: ${$height};
        `
      : ''}
`

export const StyledNavigateNextIcon = styled(NavigateNextIcon)`
  font-size: 32px;
`

export const PlusLabel = styled('div')<{ theme: Theme }>`
  background: ${colors.darkBlue};
  padding: 2px 12px;
  color: ${colors.white};
  font-weight: 700;
  font-size: 18px;
  border-radius: 50px;
  width: fit-content;
  margin-bottom: 16px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    margin-bottom: 0;
  }
`
